module.exports = __webpack_public_path__ + "whitetea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitetea.png
// module id = 905
// module chunks = 0